import { masterSupabase } from '../lib/supabase-master.js';

export async function capitalFetch(resource, init = {}) {
  const { organizationId, ...fetchInit } = init;
  const { data: { session }, error } = await masterSupabase.auth.getSession();
  if (error || !session?.access_token) {
    throw new Error('Keine aktive Clara360-Sitzung');
  }

  const headers = new Headers(fetchInit.headers || {});
  headers.set('Authorization', `Bearer ${session.access_token}`);
  headers.set('x-supabase-access-token', session.access_token);
  if (typeof organizationId === 'string' && organizationId.trim()) {
    headers.set('X-Clara-Organization-Id', organizationId.trim());
  }

  return fetch(resource, {
    ...fetchInit,
    headers,
    credentials: 'same-origin',
  });
}
